import React from 'react';
import type { IconProps } from '../types';

/** Draft / edit glyph for clinical report status (stroke; inherits `currentColor` from parent). */
export const DraftStatus = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M6 10H10.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.18799 1.81099C8.38703 1.61194 8.657 1.50012 8.93849 1.50012C9.21998 1.50012 9.48994 1.61194 9.68899 1.81099C9.88803 2.01003 9.99986 2.28 9.99986 2.56149C9.99986 2.84298 9.88803 3.11294 9.68899 3.31199L3.68399 9.31749C3.56504 9.43644 3.418 9.52346 3.25649 9.57049L1.82049 9.98949C1.77746 10.002 1.73186 10.0028 1.68844 9.99167C1.64503 9.98055 1.6054 9.95796 1.57371 9.92627C1.54202 9.89458 1.51943 9.85495 1.50831 9.81153C1.49719 9.76812 1.49794 9.72251 1.51049 9.67949L1.92949 8.24349C1.9766 8.08216 2.06361 7.9353 2.18249 7.81649L8.18799 1.81099Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DraftStatus;
